export function addCurrentPatrimonyCalled(sucess) {
    return {
        type: 'ADD_CURRENT',
        sucess,
    }
}
